import { PipeTransform, Pipe } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'formatPeriodoAnoMes',
})
export class FormatPeriodoAnoMes implements PipeTransform {
  transform(anoMes: number[], format?:string): string {

    if(!anoMes || anoMes.length === 0){
      return '';
    }

    const date = moment().locale('pt-br');
    const dateFinal = moment().locale('pt-br');

    const anoMesStr = String(anoMes[0]);
    const anoMesFinalStr = String(anoMes[anoMes.length-1]);

    date.month(Number(anoMesStr.substring(4)) - 1)
    dateFinal.month(Number(anoMesFinalStr.substring(4)) - 1)

    return `${date.format(format ? format : 'MMMM')} - ${dateFinal.format(format ? format : 'MMMM')}`;
  }
}
